module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg8.fd5879d5.png";